/**
 * This interceptor, in addition to the ReplaceProductInterceptor, replaces sideUnitRef in RemovedLeftSideUnitComponent
 * and RemovedRightSideUnitComponent if the side unit isn't sold in the current market but has a replacement product that is sold.
 *
 * When switching to BRYGGA the side unit ref was changed due to how states work. So if an old VPC or SPR is loaded, all the side unit refs need to be updated.
 */
export default class ReplaceSideUnitInterceptor {
    constructor(validProducts, invalidProducts) {
        this.replaceRef = (input) => {
            const replacements = {
                '-oldL': '-old--left',
                '-oldR': '-old--right',
                '-L': '--left',
                '-R': '--right'
            };
            const pattern = new RegExp(Object.keys(replacements).join('|'), 'g');
            return input.replace(pattern, matched => replacements[matched]);
        };
        this.getReplacementSideUnit = (sideUnitRef) => {
            const invalidSideUnit = this.invalidProducts.find(product => product.coreProductId === sideUnitRef);
            if (!invalidSideUnit)
                return;
            return invalidSideUnit.meta?.replacedBy;
        };
        this.validProducts = validProducts;
        this.invalidProducts = invalidProducts;
    }
    beforeDeserialize(json) {
        const data = JSON.parse(json);
        const entities = data.entities;
        const replacedEntities = entities.map((entity) => {
            if (entity.ref.includes('oldL') ||
                entity.ref.includes('oldR') ||
                entity.ref.includes('L') ||
                entity.ref.includes('R')) {
                const updatedSideUnitRef = this.replaceRef(entity.ref);
                const replacementSideUnit = this.getReplacementSideUnit(updatedSideUnitRef);
                entity = {
                    ...entity,
                    ref: replacementSideUnit ? replacementSideUnit : updatedSideUnitRef
                };
            }
            let components = entity.c;
            if (components?.RemovedRightSideUnitComponent) {
                const sideUnitRef = components.RemovedRightSideUnitComponent.sideUnitRef;
                const updatedSideUnitRef = this.replaceRef(sideUnitRef);
                const replacementSideUnit = this.getReplacementSideUnit(updatedSideUnitRef);
                components = {
                    ...components,
                    RemovedRightSideUnitComponent: {
                        ...components.RemovedRightSideUnitComponent,
                        sideUnitRef: replacementSideUnit ? replacementSideUnit : updatedSideUnitRef
                    }
                };
            }
            if (components?.RemovedLeftSideUnitComponent) {
                const sideUnitRef = components.RemovedLeftSideUnitComponent.sideUnitRef;
                const updatedSideUnitRef = this.replaceRef(sideUnitRef);
                const replacementSideUnit = this.getReplacementSideUnit(updatedSideUnitRef);
                components = {
                    ...components,
                    RemovedLeftSideUnitComponent: {
                        ...components.RemovedLeftSideUnitComponent,
                        sideUnitRef: replacementSideUnit ? replacementSideUnit : updatedSideUnitRef
                    }
                };
            }
            return { ...entity, c: components };
        });
        return JSON.stringify({ ...data, entities: replacedEntities });
    }
    beforeParsingComponents() { }
    beforeBuildingEntities() { }
    afterDeserializeComplete() { }
}
//# sourceMappingURL=ReplaceSideUnitInterceptor.js.map